import Storage from './storage'
import { getCurrentUser } from '../services/userProfile'

export function getUser(useLocalStorage = true) {
  let currentUser = null
  if (useLocalStorage) {
    currentUser = Storage.getEncoded('currentUser', false)
  }
  if (!currentUser) {
    currentUser = getCurrentUser()
      .then(response => {
        if (response.success) {
          return response.data
        } else {
          console.error('USER ACCESS FAILURE', response.data)
          // Throw error to preserve status code and error info
          const error = new Error('User not found')
          error.isUserError = true
          if (response.data?.response) {
            error.response = response.data.response
          } else if (response.data) {
            error.originalError = response.data
          }
          throw error
        }
      })
      .catch(error => {
        console.error('USER ACCESS FAILURE', error)
        // Mark as user error and preserve error information
        error.isUserError = true
        throw error
      })
  }
  return currentUser
}

export function shouldForceUserRefresh() {
  const { tokens = {} } = getUser()
  return Math.floor(Date.now() / 1000) >= tokens.identity?.exp
}
